<template>
    <div class="puzzle-org">
        <div><iframe src='https://puzzel.org/en/label-this/embed?p=-MbfktFEeyewrTTKL77s' width='100%' height='800' frameborder='0'></iframe></div>
    </div>
</template>
